module.exports = __webpack_public_path__ + "img/art_2.58fe17be.png";